export default function Stethoscope(
	props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
	return (
		<svg
			width="36"
			height="36"
			viewBox="0 0 36 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M7.425 3.75317C7.43023 3.84546 7.46436 3.93377 7.52255 4.00559C7.58073 4.07741 7.66004 4.12912 7.74923 4.15339C7.83842 4.17766 7.93299 4.17326 8.01955 4.14083C8.1061 4.10839 8.18027 4.04955 8.23154 3.97264C8.28281 3.89573 8.3086 3.80464 8.30525 3.71226C8.30191 3.61989 8.26959 3.5309 8.21288 3.45791C8.15618 3.38491 8.07795 3.33159 7.98927 3.30551C7.90059 3.27942 7.80595 3.28188 7.71875 3.31255H6.25C5.47093 3.31255 4.72376 3.62203 4.17287 4.17292C3.62199 4.72381 3.3125 5.47097 3.3125 6.25005V13.5938C3.3125 15.931 4.24096 18.1725 5.89362 19.8252C7.54629 21.4778 9.78778 22.4063 12.125 22.4063C13.2823 22.4063 14.4282 22.1784 15.4974 21.7355C16.5666 21.2926 17.5381 20.6435 18.3564 19.8252C19.1747 19.0069 19.8238 18.0354 20.2667 16.9662C20.7096 15.897 20.9375 14.7511 20.9375 13.5938V6.25005C20.9375 5.47097 20.628 4.72381 20.0771 4.17292C19.5262 3.62203 18.7791 3.31255 18 3.31255H16.5312C16.5023 3.34148 16.4794 3.37583 16.4637 3.41363C16.4481 3.45143 16.44 3.49194 16.44 3.53286C16.44 3.57378 16.4481 3.61429 16.4637 3.65209C16.4794 3.68989 16.5023 3.72424 16.5312 3.75317C16.5602 3.7821 16.5945 3.80505 16.6323 3.82071C16.6701 3.83637 16.7106 3.84443 16.7516 3.84443C16.7925 3.84443 16.833 3.83637 16.8708 3.82071C16.9086 3.80505 16.9429 3.7821 16.9719 3.75317"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.125 22.4062V23.875C12.125 26.2122 13.0535 28.4537 14.7061 30.1064C16.3588 31.759 18.6003 32.6875 20.9375 32.6875C23.2747 32.6875 25.5162 31.759 27.1689 30.1064C28.8215 28.4537 29.75 26.2122 29.75 23.875V18"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M26.8125 15.0625C26.8125 15.8416 27.122 16.5887 27.6729 17.1396C28.2238 17.6905 28.9709 18 29.75 18C30.5291 18 31.2762 17.6905 31.8271 17.1396C32.378 16.5887 32.6875 15.8416 32.6875 15.0625C32.6875 14.2834 32.378 13.5363 31.8271 12.9854C31.2762 12.4345 30.5291 12.125 29.75 12.125C28.9709 12.125 28.2238 12.4345 27.6729 12.9854C27.122 13.5363 26.8125 14.2834 26.8125 15.0625Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
